import { Navigate } from 'react-router-dom';
import { getSecureItem } from '../Utils/secureStorage';
const GuestRoute = ({ Component, updateHeaderFun }) => {
  const loginUser = getSecureItem('accessToken');
  let isLogin = false;
  if (loginUser) {
    isLogin = true;
  }
  return isLogin ? (
    <Navigate to='/admin/dashboard' />
  ) : (
    <Component updateHeaderFun={typeof updateHeaderFun !== 'undefined' ? updateHeaderFun : ''} />
  );
};
export default GuestRoute;
